<template>
  <div class="cms-content" v-html="cmsHtml" v-if="cmsHtml"></div>
</template>

<script>

  export default {
    props: ['type','lang'],
    data: function () {
      return {
        cmsHtml:''
      }
    },
    methods: {
      getCms(){
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.axios.get('/api/junket/info/term', {
          params: {
            type:this.type,
            lang:this.lang
          }
        }).then((res) => {
          if (res.code === 200) {
            this.cmsHtml = res.data.content;
          }
        }).finally(() => {
          loading.close();
        })
      }
    },
    created(){
      this.getCms()
    }
  }


</script>
